export default __webpack_public_path__ + "static/media/net.7f14d4e0.png";